export default __webpack_public_path__ + "static/media/ts-cut.e8506b8d.svg";